

const DaysOfWeek = [
    'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'
];

export default DaysOfWeek;
